"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTicketingThankYouMockData = exports.getTicketingThankYouSampleDonor = exports.FROALA_REALISTIC_THANK_YOU_BODY = exports.FROALA_SHOP_THANK_YOU_BODY = exports.FROALA_RAFFLE_FIGMA_THANK_YOU_BODY = exports.FROALA_EVENT_FIGMA_THANK_YOU_BODY = exports.MOCK_TAX_RECEIPT_URL = exports.MEMBERSHIP_MULTIPLE_TICKETS = void 0;
const luxon_1 = require("luxon");
const enums_1 = require("../../enums");
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const helpers_1 = require("../helpers");
const icons_1 = require("../icons");
const format_mock_currency_1 = require("./format-mock-currency");
const organization_page_button_1 = require("./organization-page-button");
const EVENT_FIGMA_TICKETS = [
    { number: 4, title: "General Admission", variantLabel: "", amountCents: 2500 },
];
exports.MEMBERSHIP_MULTIPLE_TICKETS = [
    { number: 2, title: "Adult Membership", variantLabel: "", amountCents: 4000 },
    { number: 2, title: "Kids Membership", variantLabel: "", amountCents: 1000 },
];
const EVENT_FIGMA_ADD_ONS = [
    { number: 4, title: "Drink Ticket", variantLabel: "", amountCents: 1200 },
    { number: 1, title: "Parking Pass", variantLabel: "", amountCents: 1000 },
];
const RAFFLE_FIGMA_TICKETS = [
    { number: 4, title: "One chance of winning", variantLabel: "", amountCents: 2500 },
];
const MEMBERSHIP_FIGMA_TICKETS = [
    { number: 1, title: "Membership", variantLabel: "", amountCents: 2500 },
];
const SHOP_MOCK_TICKETS = [
    {
        number: 1,
        title: "T-Shirt",
        variantLabel: "Medium, Black",
        variantValues: ["Medium", "Black"],
        amountCents: 1000,
    },
    {
        number: 1,
        title: "T-Shirt",
        variantLabel: "Large, White",
        variantValues: ["Large", "White"],
        amountCents: 1500,
    },
];
const MOCK_MEMBER_CARD_URL = "https://example.com/member-card.pdf";
exports.MOCK_TAX_RECEIPT_URL = "https://example.com/tax-receipt.pdf";
const TICKETS_BY_CATEGORY = {
    [enums_1.TicketingFormCategory.Event]: EVENT_FIGMA_TICKETS,
    [enums_1.TicketingFormCategory.Shop]: SHOP_MOCK_TICKETS,
    [enums_1.TicketingFormCategory.MembershipV2]: MEMBERSHIP_FIGMA_TICKETS,
    [enums_1.TicketingFormCategory.Lottery]: RAFFLE_FIGMA_TICKETS,
    [enums_1.TicketingFormCategory.Sweepstakes]: RAFFLE_FIGMA_TICKETS,
    [enums_1.TicketingFormCategory.Auction]: [{ number: 1, title: "Gift Basket", variantLabel: "", amountCents: 4000 }],
    [enums_1.TicketingFormCategory.Custom]: [{ number: 2, title: "General Admission", variantLabel: "", amountCents: 2500 }],
};
const FALLBACK_TICKETS = [
    { number: 4, title: "General Admission", variantLabel: "", amountCents: 2500 },
];
const BASE_CATEGORY = {
    isPurchaseWording: false,
    hasContributionByDefault: true,
    defaultBuyerAddress: "San Diego, CA",
    defaultFirstName: "John",
    defaultLastName: "Smith",
    supportsExtraDonation: true,
    extraDonationCents: 1000,
    contributionCents: 100,
    contributionDisplay: "$1.00",
    orgEmail: "hello@yourorg.org",
    isSingleTicketByDefault: "auto",
    hidesWebTicket: false,
    defaultETicketUrl: "",
};
const FIGMA_BASE = {
    ...BASE_CATEGORY,
    defaultBuyerAddress: "San Diego, CA",
    defaultFirstName: "John",
    defaultLastName: "Smith",
    orgEmail: "hello@thecoolfoundation.org",
    isSingleTicketByDefault: false,
};
const CATEGORY_CONFIG = {
    [enums_1.TicketingFormCategory.Event]: {
        ...FIGMA_BASE,
        extraDonationCents: 2500,
    },
    [enums_1.TicketingFormCategory.Shop]: {
        ...FIGMA_BASE,
        isPurchaseWording: true,
        extraDonationCents: 2500,
    },
    [enums_1.TicketingFormCategory.Lottery]: {
        ...FIGMA_BASE,
        isPurchaseWording: true,
        supportsExtraDonation: false,
    },
    [enums_1.TicketingFormCategory.Sweepstakes]: {
        ...FIGMA_BASE,
        isPurchaseWording: false,
        supportsExtraDonation: false,
    },
    [enums_1.TicketingFormCategory.MembershipV2]: {
        ...FIGMA_BASE,
        supportsExtraDonation: false,
        isSingleTicketByDefault: "auto",
        hidesWebTicket: true,
        defaultETicketUrl: MOCK_MEMBER_CARD_URL,
    },
    [enums_1.TicketingFormCategory.Custom]: {
        ...BASE_CATEGORY,
        isPurchaseWording: true,
    },
};
const FROALA_PARAGRAPH_STYLE = "width:100%;margin:0px;box-sizing:inherit;color:rgb(0, 0, 0);line-height:1.5;";
exports.FROALA_EVENT_FIGMA_THANK_YOU_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hi John,</p>
<p style="${FROALA_PARAGRAPH_STYLE}">We can't wait to see you at Christmas Movie Night! Grab your popcorn and get ready for a cozy evening.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Doors open 30 minutes before showtime. Bring your e-ticket to check in at the door.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Warm regards,</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><strong>The Cool Foundation Team</strong></p>`;
exports.FROALA_RAFFLE_FIGMA_THANK_YOU_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hi John,</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Thank you for supporting our Annual Raffle! Your entries are confirmed — good luck!</p>
<p style="${FROALA_PARAGRAPH_STYLE}">The draw takes place on the date below. Winners will be notified by email.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Warm regards,</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><strong>The Cool Foundation Team</strong></p>`;
exports.FROALA_SHOP_THANK_YOU_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hi John,</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Warm regards,</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><strong>The Cool Foundation Team</strong></p>`;
exports.FROALA_REALISTIC_THANK_YOU_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hi John,</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Thank you so much for your purchase! We're thrilled to welcome you to the Smile Foundation Spring Gala. Your support helps us continue making a difference in our community.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Doors open at 7:00 PM. Dress code is cocktail attire.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">If you have any questions, reply to this email and our team will get back to you within one business day.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">See you soon!</p>
<p style="${FROALA_PARAGRAPH_STYLE}">— The Smile Foundation Team</p>`;
const EMPTY_EVENT_DATE_FIELDS = {
    eventStartDate: "",
    eventEndDate: "",
    eventMonth: "",
    eventDay: "",
    eventWeekday: "",
    eventDateLabel: "",
    eventTimeRange: "",
    calendarFileUrl: "",
};
const buildEventDateFields = (startUtc, endUtc, locale, address, title, isPhysicalEvent, timezone) => {
    if (!startUtc || !endUtc) {
        return EMPTY_EVENT_DATE_FIELDS;
    }
    const start = (0, helpers_1.toDateTime)(startUtc);
    const end = (0, helpers_1.toDateTime)(endUtc);
    const calendarFields = (0, helpers_1.buildEventCalendarFields)({ startUtc: start, endUtc: end, isPhysicalEvent, address, title, timezone }, locale);
    if (!("eventMonth" in calendarFields)) {
        return EMPTY_EVENT_DATE_FIELDS;
    }
    const zonedStart = start.setZone(timezone || "America/New_York");
    const zonedEnd = end.setZone(timezone || "America/New_York");
    return {
        ...calendarFields,
        eventStartDate: zonedStart.toFormat("LLLL d, yyyy 'at' h:mm a"),
        eventEndDate: zonedEnd.toFormat("LLLL d, yyyy 'at' h:mm a"),
    };
};
const sumTicketAmountCents = (tickets) => tickets.reduce((sum, t) => sum + (t.amountCents ?? 0), 0);
const buildMockOrderTaxes = (appliedTaxes, formatAmount) => {
    const taxMarkers = appliedTaxes.map((_, index) => (appliedTaxes.length === 1 ? "T" : `T${index + 1}`));
    return {
        ticketTaxFields: appliedTaxes.length > 0
            ? { taxMarkers: taxMarkers.join(", "), hasMultipleTaxMarkers: taxMarkers.length > 1 }
            : {},
        orderTaxes: appliedTaxes.map((tax, index) => ({
            marker: taxMarkers[index],
            label: `${tax.name} (${tax.rateDisplay})`,
            amount: formatAmount(tax.amountCents),
        })),
        soldByTaxNumbers: appliedTaxes
            .filter((tax) => Boolean(tax.registrationNumber))
            .map((tax) => ({ name: tax.name, number: tax.registrationNumber })),
        taxTotalCents: appliedTaxes.reduce((sum, tax) => sum + tax.amountCents, 0),
    };
};
const withDerivedPrice = (line, formatAmount) => ({
    ...line,
    formattedPrice: line.formattedPrice ?? formatAmount(line.amountCents ?? 0),
});
const buildOrderLines = ({ categoryTickets, addOnsOverride, ticketTaxFields, isFreeEvent, isEventForm, formatAmount, }) => {
    if (isFreeEvent) {
        return {
            tickets: categoryTickets.map((ticket) => ({ ...ticket, formattedPrice: "Free", amountCents: 0 })),
            addOns: [],
        };
    }
    const categoryAddOns = addOnsOverride ?? (isEventForm ? EVENT_FIGMA_ADD_ONS : []);
    const toLine = (line) => ({
        ...withDerivedPrice(line, formatAmount),
        ...(line.taxMarkers === undefined ? ticketTaxFields : {}),
    });
    return {
        tickets: categoryTickets.map(toLine),
        addOns: categoryAddOns.map(toLine),
    };
};
const buildReceiptOrder = ({ categoryTickets, addOnsOverride, taxes, isFreeEvent, isDonationOnly, isEventForm, formatAmount, }) => {
    const { ticketTaxFields, orderTaxes, soldByTaxNumbers, taxTotalCents } = buildMockOrderTaxes(isFreeEvent || isDonationOnly ? [] : taxes, formatAmount);
    const orderLines = buildOrderLines({
        categoryTickets,
        addOnsOverride,
        ticketTaxFields,
        isFreeEvent,
        isEventForm,
        formatAmount,
    });
    return {
        orderTaxes,
        soldByTaxNumbers,
        taxTotalCents,
        tickets: isDonationOnly ? [] : orderLines.tickets,
        addOns: isDonationOnly ? [] : orderLines.addOns,
    };
};
const parseAmountCents = (formatted) => {
    if (!formatted) {
        return 0;
    }
    const cleaned = formatted.replace(/[^0-9.]/g, "");
    const value = Number.parseFloat(cleaned);
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
};
const BASE_MOCK = {
    donorEmail: "john.smith@example.com",
    email: "john.smith@example.com",
    companyName: "",
    simplykConnectionLink: "https://zeffy.com/my-account",
    shouldDisplayDonorRefundOptionInEmail: true,
    donorRefundPageLink: "https://zeffy.com/tip-adjustment",
    hasGiftAidConfirmation: false,
    hasGiftAid: "No",
    shouldDisplayCharityNumberOnTransactionReceipt: false,
    charityNumber: "",
    transactionReceiptCharityNumberLabel: "",
    registeredCharityName: "",
    registeredCharityNumber: "",
    giftaidExtraAmount: "",
    isPurchaseWording: true,
    subject: "Thank you for your purchase!",
    isRecurrent: false,
    isMonthly: false,
    isMembership: false,
    isManualEntry: false,
    webBasedEventTicketUrl: "https://example.com/web-ticket/abc123",
    receiptUrl: "",
    eventOnlineUrl: "",
};
const getTicketingThankYouSampleDonor = (formCategory) => {
    const config = CATEGORY_CONFIG[formCategory] ?? BASE_CATEGORY;
    return {
        firstName: config.defaultFirstName,
        lastName: config.defaultLastName,
        buyerAddress: config.defaultBuyerAddress,
    };
};
exports.getTicketingThankYouSampleDonor = getTicketingThankYouSampleDonor;
const buildTicketingThankYouMockData = ({ formCategory, orgName, eventTitle, color, isDarkMode, body, hasExtraDonation, address, firstOccurrenceStartUtc, firstOccurrenceEndUtc, timezone, currentDate, receiptUrl, webBasedEventTicketUrl, eTicketUrl, isFreeEvent = false, isDonationOnly = false, isOfflinePayment = false, isCashPayment = false, hasZeffyContribution, firstName, lastName, buyerAddress, paymentMethodDisplay, eventDateDisplay, locale = "en", country, discountAmount, shippingFeeAmount, pickupAddress, pickupInstructions, shippingAddress, isRecurrent, isMonthly, isBuyerAMember, hasWalletButtons = true, assetBaseUrl = "", taxes = [], tickets: ticketsOverride, addOns: addOnsOverride, contributionCents: contributionCentsOverride, organizationPageUrl, }) => {
    const formatAmount = (cents) => (0, format_mock_currency_1.formatMockCurrencyAmount)(cents, { locale, country });
    const labels = (0, email_templates_1.getEmailLabels)(locale);
    const config = CATEGORY_CONFIG[formCategory] ?? BASE_CATEGORY;
    const categoryTickets = ticketsOverride ?? TICKETS_BY_CATEGORY[formCategory] ?? FALLBACK_TICKETS;
    const isEventForm = formCategory === enums_1.TicketingFormCategory.Event;
    const isDrawingForm = (0, enums_1.isDrawingFormCategory)(formCategory);
    const isRaffleForm = formCategory === enums_1.TicketingFormCategory.Lottery;
    const isSweepstakesForm = formCategory === enums_1.TicketingFormCategory.Sweepstakes;
    const isMembership = formCategory === enums_1.TicketingFormCategory.MembershipV2;
    const { tickets, addOns, orderTaxes, soldByTaxNumbers, taxTotalCents } = buildReceiptOrder({
        categoryTickets,
        addOnsOverride,
        taxes,
        isFreeEvent,
        isDonationOnly,
        isEventForm,
        formatAmount,
    });
    const ticketTotalCents = sumTicketAmountCents(tickets) + sumTicketAmountCents(addOns);
    const extraDonationCents = isDonationOnly || (hasExtraDonation && config.supportsExtraDonation) ? config.extraDonationCents : 0;
    const discountCents = parseAmountCents(discountAmount);
    const shippingFeeCents = isFreeEvent ? 0 : parseAmountCents(shippingFeeAmount);
    const wantsContribution = hasZeffyContribution ?? (isFreeEvent ? false : config.hasContributionByDefault);
    const contributionCents = isOfflinePayment || !wantsContribution ? 0 : (contributionCentsOverride ?? config.contributionCents);
    const hasContribution = contributionCents > 0;
    const shouldDisplayContributionLine = !isFreeEvent && !isOfflinePayment;
    const orderCents = ticketTotalCents + extraDonationCents + shippingFeeCents - discountCents + taxTotalCents;
    const paidCents = orderCents + contributionCents;
    const eventDateFields = buildEventDateFields(firstOccurrenceStartUtc, firstOccurrenceEndUtc, locale, address ?? null, eventTitle || "Your Event", isEventForm, timezone);
    const hasEventVenue = Boolean(address);
    const eventCalendarBesideDate = isDrawingForm &&
        Boolean(eventDateFields.eventStartDate) &&
        Boolean(eventDateFields.calendarFileUrl) &&
        !hasEventVenue;
    const isSingleTicket = config.isSingleTicketByDefault === "auto"
        ? tickets.reduce((sum, t) => sum + t.number, 0) === 1
        : config.isSingleTicketByDefault;
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    const iconGiftAid = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.giftAidDark : icons_1.EMAIL_ICON_DATA_URI.giftAidLight;
    const iconTintColor = isDarkMode ? (0, email_theme_tokens_1.getGmailDarkSafeBrandColor)(theme.tBrand) : theme.tBrand;
    return {
        ...(0, organization_page_button_1.buildOrganizationPageButtonMockFields)(organizationPageUrl, theme),
        ...BASE_MOCK,
        ...eventDateFields,
        ...(eventDateDisplay ?? {}),
        labels,
        iconCalendar: (0, icons_1.tintIconSvgDataUri)("calendar", iconTintColor),
        iconPin: (0, icons_1.tintIconSvgDataUri)("pin", iconTintColor),
        iconEdit: (0, icons_1.tintIconSvgDataUri)("edit", iconTintColor),
        iconZeffyLogo,
        iconGiftAid,
        lang: locale,
        orgName: orgName || "Bright Futures Foundation",
        orgEmail: config.orgEmail,
        eventTitle: eventTitle || "Your Event",
        address: buyerAddress ?? config.defaultBuyerAddress,
        eventOnlineUrl: "",
        isEventForm,
        isLotteryForm: isRaffleForm,
        isSweepstakes: isSweepstakesForm,
        eventCalendarBesideDate,
        date: (currentDate ?? luxon_1.DateTime.now()).toFormat("LLLL d, yyyy"),
        paymentMethodDisplay: paymentMethodDisplay ?? "Card (••• 4242)",
        firstName: firstName ?? config.defaultFirstName,
        lastName: lastName ?? config.defaultLastName,
        isRecurrent: isRecurrent ?? isMembership,
        isMonthly: isMonthly ?? false,
        theme,
        tickets,
        addOns,
        orderTaxes,
        soldByTaxNumbers,
        isSingleTicket,
        isMembership,
        isBuyerAMember: isBuyerAMember ?? true,
        isPurchaseWording: config.isPurchaseWording,
        subject: isSweepstakesForm
            ? "Your Sweepstakes participation is confirmed"
            : isFreeEvent
                ? "Thank you for your registration!"
                : "Thank you for your purchase!",
        extraDonation: extraDonationCents > 0 ? formatAmount(extraDonationCents) : "",
        shippingFeeAmount: shippingFeeCents > 0 ? formatAmount(shippingFeeCents) : undefined,
        orderAmount: formatAmount(orderCents),
        isFreeOrder: orderCents - extraDonationCents === 0,
        isDonationOnly,
        hasContribution,
        shouldDisplayContributionLine,
        isOfflinePayment,
        isCashPayment,
        contributionAmount: formatAmount(contributionCents),
        paidAmount: formatAmount(paidCents),
        shouldDisplayDonorRefundOptionInEmail: hasContribution && !isOfflinePayment,
        message: body,
        receiptUrl: isFreeEvent ? "" : (receiptUrl ?? BASE_MOCK.receiptUrl),
        webBasedEventTicketUrl: config.hidesWebTicket ? "" : (webBasedEventTicketUrl ?? BASE_MOCK.webBasedEventTicketUrl),
        eTicketUrl: eTicketUrl ?? config.defaultETicketUrl,
        discountAmount: discountAmount || "",
        pickupAddress: pickupAddress ?? "",
        pickupInstructions: pickupInstructions ?? "",
        pickupMapLink: pickupAddress ? (0, helpers_1.buildGoogleMapsUrl)(pickupAddress) : "",
        shippingAddress: shippingAddress ?? "",
        appleWalletUrl: hasWalletButtons ? "https://example.com/wallet-pass/apple/abc123" : "",
        googleWalletUrl: hasWalletButtons ? "https://example.com/wallet-pass/google/abc123" : "",
        badgeAppleWalletImg: `${assetBaseUrl}/images/wallet/add-to-apple-wallet.png`,
        badgeGoogleWalletImg: `${assetBaseUrl}/images/wallet/add-to-google-wallet.png`,
    };
};
exports.buildTicketingThankYouMockData = buildTicketingThankYouMockData;
